import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getUser } from "../../../Api/CheckTokenAndGEtUser";

const LogInstate = () => {
  const { currentUser, isGettingUser } = useSelector((state) => state.User);
  const dispatch = useDispatch();

  useEffect(() => {
    getUser(dispatch);
  }, []);

  return (
    <div>
      <nav className="flex items-center justify-center bg-[#55A7FF] text-white py-3">
        <ul className="flex items-center justify-center w-full md:w-auto space-x-10">
          {isGettingUser && <li className="font-bold">loading... </li>}

          {currentUser ? (
            <li className="font-bold">Welcome back {currentUser.name} </li>
          ) : (
            !isGettingUser && (
              <li className="font-bold">
                Create an account to continue shopping
              </li>
            )
          )}
        </ul>
      </nav>
    </div>
  );
};

export default LogInstate;
